import { processSession } from "./process-session"

const diagnoses = {
  processSession,
}

export default diagnoses
